import React, { useState, useCallback, useEffect } from 'react'
import 'froala-editor/js/plugins.pkgd.min.js'
import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import FroalaEditor from 'react-froala-wysiwyg'
import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import config from './config'

const FroalaTextEditor = ({ clubUuid, input: { onChange, value }, token }) => {
  const [content, setContent] = useState('')

  window.REACT_APP_API_URL = process.env.REACT_APP_API_ENDPOINT
  const API_URL = `${window.REACT_APP_API_URL}/v2/clubs/${clubUuid}/froala-upload`

  useEffect(() => {
    if (value && content && value === content) {
      return
    }

    if (value) {
      setContent(value)
    } else {
      setContent('')
    }
  }, [value])

  const onEditorContentChange = useCallback((newContent) => {
    const cleanContent = newContent.replace('id="isPasted"', '')
    setContent(cleanContent)
    onChange(cleanContent)
  }, [])

  return (
    <FroalaEditor
      tag="textarea"
      config={{
        ...config,
        imageUploadURL: API_URL,
        videoUploadURL: API_URL,
        fileUploadURL: API_URL,

        requestHeaders: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },

      }}
      model={content}
      onModelChange={onEditorContentChange}
    />
  )
}

FroalaTextEditor.propTypes = {
  input: PropTypes.shape().isRequired,
  token: PropTypes.string.isRequired,
  clubUuid: PropTypes.string.isRequired,
}

export default compose(
  connect(({ auth, clubs }) => ({
    token: auth.token,
    clubUuid: clubs.current.uuid,
  }))
)(FroalaTextEditor)
